import React from 'react';

const TemplateReceiveOrderHeader = () => {
  return (
    <div className="flex flex-col gap-1 items-center pt-5">
      <div className="text-lg font-bold">ใบรับสินค้า</div>
      <div className="font-bold">บริษัท อัลไลด์ อโกร จำกัด</div>
      <div className="font-bold">ALLIED AGRO CO., LTD.</div>
      <div className="">โทร. 028612223-5 แฟ็กซ์ 028612227</div>
    </div>
  );
};

export default TemplateReceiveOrderHeader;
